import styled from 'styled-components';

export const DetailContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    min-height: 0;
`;

export const DetailTopBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 8px 24px;
    border-bottom: 1px solid #e5e7eb;
    background: white;
    flex-shrink: 0;
`;

export const DetailTopBarLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    min-width: 0;
`;

export const AgentNameGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
`;

export const AgentNameRow = styled.span`
    font-size: 15px;
    font-weight: 600;
    color: #111827;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const AgentMetaRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const DetailTopBarRight = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
`;

export const TabList = styled.div`
    display: flex;
    gap: 4px;
    padding: 0 24px;
    border-bottom: 1px solid #e5e7eb;
    background: white;
    flex-shrink: 0;
`;

export const TabButton = styled.button<{ $isActive: boolean }>`
    padding: 10px 16px;
    font-size: 13px;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: none;
    background: none;
    cursor: pointer;
    border-bottom: 2px solid ${props => (props.$isActive ? '#2563eb' : 'transparent')};
    color: ${props => (props.$isActive ? '#2563eb' : '#6b7280')};
    transition: all 0.15s ease;
    margin-bottom: -1px;

    &:hover {
        color: ${props => (props.$isActive ? '#2563eb' : '#374151')};
    }
`;

export const TabContent = styled.div`
    flex: 1;
    min-height: 0;
    overflow: hidden;
    background: #f9fafb;
    position: relative;
`;

export const OverviewScroll = styled.div`
    position: absolute;
    inset: 0;
    overflow-y: auto;
`;

export const OverviewGrid = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px;
`;

export const CardHeaderBar = styled.div`
    padding: 10px 16px;
    background: #f9fafb;
    border-bottom: 1px solid #f3f4f6;
    border-radius: 12px 12px 0 0;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const SectionIcon = styled.span<{ $color: string }>`
    display: flex;
    align-items: center;
    color: ${props => props.$color};
    flex-shrink: 0;
`;

export const HistoryContainer = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

export const HistoryHeader = styled.div`
    height: 60px;
    padding: 0 24px;
    border-bottom: 1px solid #e5e7eb;
    background: white;
    flex-shrink: 0;
    display: flex;
    align-items: center;
`;

export const HistoryHeaderContent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    width: 100%;
`;

export const HistoryHeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const HistoryTableWrapper = styled.div`
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;
